const FallbackUI = () => (
  <div style={{ padding: 40, textAlign: "center" }}>
    <h1>Ooops, something went wrong.</h1>
    <p>We’re working on it :)</p>
  </div>
);
export default FallbackUI;
